import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';

import {
    Paper, Fab, Typography, Tooltip, Button, Container
} from '@mui/material';

import {
    DataGrid,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    GridToolbar,
    useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';

// Custom components and functions
import CustomMessage from '../../utils/components/CustomMessage';
import CustomStatusChip from '../../utils/components/CustomStatusChip';
import useWindowDimensions from '../../utils/functions/useWindowDimensions';
import { formatMoney, getDate } from '../../utils/functions/Utils';
import LocaleTextDataGrid from '../../utils/functions/LocaleTextDataGrid';

const TablaGastos = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState('');

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });
    const { height } = useWindowDimensions();

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Gastos';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        try {
            let res = await axios.get('/api/gastos');

            if (res.status === 200) {
                if (res.data.length <= 1) {
                    res.data[0].fecha = getDate(res.data[0].fecha, 'DDDD');
                    res.data[0].monto = `$ ${formatMoney(res.data[0].monto)}`
                    setData(res.data);
                }
                else {
                    let tmp = res.data.map((item) => {
                        item.fecha = getDate(item.fecha, 'DDDD');
                        item.monto = `$ ${formatMoney(item.monto)}`
                        return item;
                    });
                    setData(tmp);
                }
                document.title = 'Gastos';
            }
        } catch (err) {
            // setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar las cotizaciones, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const renderProducts = () => {
        if (data.length < 0) return (<div>No hay gastos registrados</div>);
        return (
            <div >
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                    <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    <Typography variant='h5' align='left' sx={{ mt: 1, mb: 1, fontWeight: 700, ml: 3 }}>Gastos</Typography>
                </div>
                <DataGrid
                    autoPageSize={true}
                    sx={{ '& .MuiDataGrid-toolbarContainer': { position: 'fixed', top: '70px', right: '24px' }, '& .MuiButtonBase-root': { color: 'comp.gray' }, '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                    style={{ height: `${height - 120}px`, width: '100%', overflow: 'hidden' }}
                    localeText={LocaleTextDataGrid}
                    rows={data}
                    density='compact'
                    getRowId={(row) => row._id}
                    onCellClick={(e) => { setSelected(e.row._id) }}
                    onCellDoubleClick={(e) => { navigate(`/gastos/editarGasto/${e.row._id}`, { target: '_blank' }) }}
                    columns={[
                        { field: 'fecha', headerName: 'Fecha', align: 'right', headerAlign: 'right', flex: 1, minWidth: 200 },
                        {
                            field: 'tipoDeMovimiento',
                            flex: 1,
                            minWidth: 200,
                            headerName: 'Tipo de Gasto',
                            headerClassName: 'text-bold',
                            align: 'center',
                            headerAlign: 'center',
                            renderCell: (params) => (
                                <CustomStatusChip estatus={params.row.tipoDeMovimiento} label={params.row.tipoDeMovimiento} />
                            ),
                        },
                        { field: 'monto', flex: 1, headerName: 'Monto', align: 'center', headerAlign: 'center', minWidth: 200, cellClassName: 'text-bold' },
                        { field: 'concepto', flex: 1, headerName: 'Concepto', align: 'center', headerAlign: 'center', minWidth: 200, },
                        { field: 'responsable', flex: 1, headerName: 'Responsable', align: 'center', headerAlign: 'center', minWidth: 200, },
                    ]}
                    pagination
                    slots={{
                        pagination: CustomPagination,
                        toolbar: GridToolbar
                    }}
                    initialState={{
                        ...data.initialState,
                        pagination: { paginationModel: { pageSize: 25 } },
                    }}
                />
            </div>
        )
    }

    return (
        <Container maxWidth='xxl' sx={{ width: '100%', overflow: 'hidden', margin: '0px', padding: '4px 4px !important' }}>
            <Paper>
                <Link to='/gastos/agregarGasto'>
                    <Tooltip title='Agregar gasto' placement='top' arrow>
                        <Fab aria-label="add" color='success' style={{ position: 'fixed', bottom: '8px', left: '8px', zIndex: '10', color: '#FFF' }}>
                            <i className="fad fa-plus fa-2x"></i>
                        </Fab>
                    </Tooltip>
                </Link>

                {selected !== '' ?
                    <div>

                        <Link target='_blank' to={{ pathname: `/gastos/editarGasto/${selected}`, state: { id: selected } }} style={{ textDecoration: 'none' }}>
                            <Tooltip title='Editar' placement='top' arrow>
                                <Fab aria-label="add" color='warning' style={{ position: 'fixed', bottom: '8px', left: '98px', zIndex: '10', color: '#FFF' }}>
                                    <i className="fad fa-edit fa-2x"></i>
                                </Fab>
                            </Tooltip>
                        </Link>
                    </div>
                    : null}
                {renderProducts()}
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

function Pagination({ page, onPageChange, className }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
        />
    );
}

function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default TablaGastos;